var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"queryBuilderContainer"}},[_c('query-builder',{attrs:{"header-title":"Edit DMS Query","query-id":this.$route.params.id,"is-template":false},on:{"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }